import { Container, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

export const LoadingFallback = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Container
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default, // Using theme background color
        color: theme.palette.text.primary, // Using theme text color
        padding: theme.spacing(4),
        textAlign: 'center', // Center align text for better readability
      }}
      maxWidth={false}
    >
      <Typography variant="h6" color="textSecondary" gutterBottom>
        {t('loading')}
      </Typography>
    </Container>
  )
}
